// pages/WritingArticlePage.jsx
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import WritingArticle from "../components/WritingArticle";
import { writingPieces } from "../data/writingData";

const WritingArticlePage = () => {
  const { slug } = useParams();

  // Find the article with matching slug
  const article = Object.values(writingPieces).find(
    (piece) => piece.slug === slug,
  );

  if (!article) {
    return <Navigate to="/writing" replace />;
  }

  return (
    <>
      <WritingArticle
        title={article.title}
        authors={article.authors || []}
        date={article.date}
        content={article.content}
        pdfUrl={article.pdfUrl}
      />
    </>
  );
};

export default WritingArticlePage;
